import { render } from "./LbrxCreateCustomer.vue?vue&type=template&id=789f79e6&scoped=true"
import script from "./LbrxCreateCustomer.vue?vue&type=script&lang=js"
export * from "./LbrxCreateCustomer.vue?vue&type=script&lang=js"

import "./LbrxCreateCustomer.vue?vue&type=style&index=0&id=789f79e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789f79e6"]])

export default __exports__